<template>
  <!--
    Declaration sample :
    <checklist-status :datatable="sysacq_table" />

    <script>
      import ChecklistStatus from "../components/UI_kit/ChecklistStatus.vue"

      export default {
        components: {
          ChecklistStatus,
        },
      }

      data() {
          return {

          }
        }
    </script>
  -->
  <div class="d-flex text-subtitle-2">
    <div
    v-for="status in reversedData"
    :key="status.value"
    class="pt-2"
  >
      <div class="d-flex">
        <div class="pr-1">
          <icon
            :icon="status.icon"
            height="21px"
            :color="status.color"
          />
        </div>
        <div style="width: 20px;">
          {{ status.val_count }}
        </div>
      </div>
    </div>
  </div>

</template>


<script>
    import { Icon } from '@iconify/vue2'

    export default {
      name: "CheckListStatus",

      components: {
        Icon,
      },

      props: {
        data: {
          type: Array,
          required: false,
        },
      },

      data() {
        return {
        }
      },

      watch: {},

      computed: {
  reversedData() {
    // Make a shallow copy and reverse it so the original prop isn't mutated
    return this.data ? [...this.data].reverse() : [];
  }
},

      methods: {},

    }
</script>

<style scoped>
  .text-subtitle-2 {
    /* font-size:.775rem!important;
    font-weight:500;
    line-height:1.25rem;
    letter-spacing:.0071428571em!important;
    font-family:Roboto,sans-serif!important; */
    color: grey;
  }
</style>
